const listItems = document.querySelectorAll('li.custom-variant-option__list_item');

const customHeadingOptions = document.querySelectorAll('.custom-heading__option-label');

listItems.forEach(item => {
    item.addEventListener('click', function() {
        listItems.forEach(li => li.classList.remove('active'));
        this.classList.add('active');
        
        customHeadingOptions.forEach(item => item.classList.remove('active'));
    });
});

customHeadingOptions.forEach(option => {
    option.addEventListener('click', function() {
        listItems.forEach(li => li.classList.remove('active'));
        this.classList.add('active');
    });
});